import { PartialTranslation } from '../translations';

export const ur: PartialTranslation = {
  newChat: 'نئی بات چیت',
  search: 'تلاش کریں',
  user: 'صارف',
  settings: 'ترتیبات',
  language: 'زبان',
  getHelp: 'مدد حاصل کریں',
  viewAllPlans: 'تمام منصوبے دیکھیں',
  learnMore: 'مزید جانیں',
  logOut: 'لاگ آؤٹ',
  chooseLanguage: 'زبان منتخب کریں',
  chooseYourPreferredLanguage: 'اپنی ترجیحی زبان منتخب کریں',
  searchLanguages: 'زبانوں کو تلاش کریں...',
  autoDetect: 'خودکار کھوج',
  noLanguagesFound: 'کوئی زبان نہیں ملی',
  askAnything: 'کچھ بھی پوچھیں',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ذاتی',
  freePlan: 'مفت منصوبہ',
  current: 'موجودہ',
  close: 'بند کریں',
  archive: 'آرکائیو',
  delete: 'حذف کریں',
  confirmDelete: 'کیا آپ واقعی اس بات چیت کو حذف کرنا چاہتے ہیں؟',
  confirmArchive: 'کیا آپ واقعی اس بات چیت کو آرکائیو کرنا چاہتے ہیں؟',
  deleteCannotUndo: 'یہ عمل واپس نہیں کیا جا سکتا۔',
  archiveCanFind: 'آرکائیو کرنے کے بعد آپ اسے آرکائیو فہرست میں تلاش کر سکتے ہیں۔',
  resources: 'وسائل',
  addResource: 'وسائل شامل کریں',
  deleteResource: 'وسائل حذف کریں',
  noMatchingResourcesFound: 'کوئی مماثل وسائل نہیں ملے',
  noResourcesAvailable: 'کوئی وسائل دستیاب نہیں',
  hideResources: 'وسائل چھپائیں',
  showResources: 'وسائل دکھائیں',
  typeMessage: 'پیغام لکھیں...',
  thinkingOptions: 'سوچنے کے اختیارات',
  deleteFile: 'فائل حذف کریں',
  clearSelection: 'انتخاب صاف کریں',
  addAttachment: 'منسلکہ شامل کریں',
  sendMessage: 'پیغام بھیجیں',
  deepInsight: 'گہری بصیرت · سطحی تجزیہ',
  deepInsightDesc: 'اہم نکات کی فوری سمجھ',
  deepExploration: 'گہری کھوج · جامع تجزیہ',
  deepExplorationDesc: 'کثیر جہتی گہری تحقیق',
  deepDeconstruction: 'گہرا تفکیک · منظم دلیل',
  deepDeconstructionDesc: 'تہ بہ تہ ترقی پسند تجزیہ',
  contractReview: 'معاہدے کا جائزہ · خطرے کی شناخت',
  contractReviewDesc: 'شقوں کا تجزیہ اور تعمیل کی جانچ',
  textPolish: 'متن کی نکھار · پیشہ ورانہ اظہار',
  textPolishDesc: 'زبان کی بہتری اور ڈھانچے کی تبدیلی',
  legalDocuments: 'قانونی دستاویزات · معیاری مسودہ',
  legalDocumentsDesc: 'پیشہ ورانہ قانونی دستاویز نویسی',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'لاگ ان',
  register: 'رجسٹر',
  welcomeBack: 'LawHelper میں خوش آمدید',
  loginSubtitle: 'آپ کا AI قانونی تحقیق معاون',
  continueWithGoogle: 'Google کے ساتھ جاری رکھیں',
  continueWithMicrosoft: 'Microsoft کے ساتھ جاری رکھیں',
  continueWithWeChat: 'WeChat کے ساتھ جاری رکھیں',
  orContinueWith: 'یا اس کے ساتھ جاری رکھیں',
  emailTab: 'ای میل',
  phoneTab: 'فون',
  emailPlaceholder: 'اپنا ای میل درج کریں',
  phonePlaceholder: 'فون نمبر درج کریں',
  codePlaceholder: '6 ہندسوں کا کوڈ درج کریں',
  sending: 'بھیج رہا ہے...',
  verifying: 'تصدیق ہو رہی ہے...',
  verify: 'تصدیق کریں',
  sendMagicLink: 'میجک لنک بھیجیں',
  getVerificationCode: 'کوڈ حاصل کریں',
  resendCode: 'کوڈ دوبارہ بھیجیں',
  resendIn: 'دوبارہ بھیجیں',
  magicLinkSent: 'میجک لنک آپ کے ای میل پر بھیج دیا گیا',
  magicLinkHint: 'ہم آپ کے ای میل پر ایک محفوظ لنک بھیجیں گے',
  otpSent: 'تصدیقی کوڈ بھیج دیا گیا',
  agreeToTerms: 'جاری رکھ کر، آپ اتفاق کرتے ہیں',
  privacyPolicy: 'رازداری کی پالیسی',
  termsOfService: 'سروس کی شرائط',
  and: 'اور',
  privacyTitle: 'آپ کی رازداری اہم ہے',
  privacyIntro: 'بہترین تجربہ فراہم کرنے کے لیے ہم کوکیز اور اسی طرح کی ٹیکنالوجیز استعمال کرتے ہیں۔',
  essentialCookies: 'ضروری کوکیز',
  essentialDesc: 'ویب سائٹ کے کام کرنے کے لیے ضروری',
  analyticsCookies: 'تجزیاتی کوکیز',
  analyticsDesc: 'سروس کو بہتر بنانے میں مدد کرتی ہیں',
  marketingCookies: 'مارکیٹنگ کوکیز',
  marketingDesc: 'ذاتی مواد کے لیے استعمال ہوتی ہیں',
  acceptAll: 'سب قبول کریں',
  essentialOnly: 'صرف ضروری',
  customize: 'اپنی مرضی کے مطابق',
  savePreferences: 'ترجیحات محفوظ کریں',
  back: 'واپس',
  readPrivacyPolicy: 'ہماری رازداری کی پالیسی پڑھیں',
  cookiePolicy: 'کوکی پالیسی',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI جائزہ',
  aiDraft: 'AI مسودہ',
  smartAssistant: 'ٹیمپلیٹ',

  // 知识库搜索
  enableKnowledgeSearch: 'تلاش فعال کریں',
  knowledgeSearchDesc: 'AI آپ کی دستاویزات میں تلاش کرتا ہے',
  clickToDisable: 'غیر فعال',
  clickToEnable: 'فعال',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'وسائل کا پینل بند کریں',
  uploading: '%{fileName} اپلوڈ ہو رہا ہے...',
  processing: '%{fileName} پراسیس ہو رہا ہے...',
  uploadSuccess: '✓ %{fileName} اپلوڈ ہوگیا',
  uploadError: '✗ اپلوڈ ناکام: %{error}',
  quickAnswer: 'فوری جواب',
  quickAnswerDesc: 'سادہ سوالات کا فوری جواب',
  cancelRequest: 'منسوخ',
  library: 'لائبریری',
  filterAll: 'سب',
  filterChat: 'چیٹ',
  filterReview: 'جائزہ',
  filterDraft: 'مسودہ',
  filterTemplate: 'ٹیمپلیٹ',
  filterForm: 'فارم',
  thinking: 'سوچ رہا ہے...',
  thinkingProcess: 'سوچ کا عمل',
  analyzingLegalLogic: 'قانونی منطق کا تجزیہ...',
  lawhelperThinking: 'Lawhelper سوچ رہا ہے...',
  serviceError: 'سروس کی خرابی',
  uploaded: 'اپلوڈ شدہ',
  settingsGeneral: 'عمومی',
  settingsNotifications: 'اطلاعات',
  settingsAppearance: 'ظاہری شکل',
  settingsProfile: 'پروفائل',
  settingsResponseNotifications: 'جواب کی اطلاعات',
  settingsResponseNotificationsDesc: 'AI جواب مکمل ہونے پر اطلاع',
  settingsColorMode: 'رنگ موڈ',
  settingsLight: 'روشن',
  settingsDark: 'تاریک',
  settingsSystem: 'سسٹم',
  about: 'کے بارے میں',
  reviewTitle: 'دستاویز کا جائزہ',
  exitReview: 'جائزے سے باہر',
  uploadPrompt: 'جائزے کے لیے PDF اپلوڈ کریں',
  uploadButton: 'فائل منتخب کریں',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'جائزہ لیا جا رہا ہے...',
  reviewComplete: 'جائزہ مکمل',
  issuesFound: '%{count} مسائل پائے گئے',
  draftTitle: 'قانونی دستاویز کی تیاری',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'بنایا جا رہا ہے...',
  generatedSuccess: '✅ دستاویز بن گئی!',
  drafterWelcome: 'AI دستاویز مددگار میں خوش آمدید',
  drafterYouCan: 'آپ کر سکتے ہیں:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'مثالیں:',
  drafterExampleRental: '"کرایہ نامہ تیار کریں"',
  drafterExampleLabor: '"معاہدۂ ملازمت بھریں"',
  drafterInputPlaceholder: 'اپنی ضروریات بیان کریں...',
  drafterThinking: 'سوچ رہا ہے...',
  drafterHistoryTitle: 'تاریخ',
  drafterNoHistory: 'کوئی تاریخ نہیں',
  drafterNewChat: 'نئی چیٹ',
  drafterHistory: 'تاریخ',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'دستاویز محفوظ کریں',
  drafterDownload: 'دستاویز ڈاؤن لوڈ',
  drafterUndo: 'واپس',
  drafterRedo: 'دوبارہ',
  drafterBold: 'بولڈ',
  drafterItalic: 'ترچھا',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'باہر',
  drafterConfirm: 'تصدیق',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI ورک فلو',
  workflowRunning: 'چل رہا ہے...',
  workflowReady: 'تیار',
  workflowCompleted: 'مکمل',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'تبدیلیاں قبول',
  rejectChanges: 'تبدیلیاں مسترد',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'روکیں',
  restartWorkflow: 'Restart',
  startDrafting: 'تیاری شروع کریں',
  interrupt: 'Stop',
  documentSubject: 'دستاویز کا موضوع *',
  documentType: 'دستاویز کی قسم',
  jurisdiction: 'دائرہ اختیار',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'معاہدہ',
  docTypeAgreement: 'اتفاقیہ',
  docTypeNotice: 'Notice',
  docTypeLetter: 'خط',
  docTypePetition: 'Petition',
  docTypeWill: 'وصیت',
  docTypePowerOfAttorney: 'مختار نامہ',
  countryChina: 'چین',
  countryUSA: 'امریکہ',
  countryGermany: 'جرمنی',
  countryJapan: 'جاپان',
  countryFrance: 'فرانس',
  countryUK: 'برطانیہ',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ذہین دستاویز مددگار',
  smartDocChatTitle: 'AI دستاویز مددگار',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'فائل منتخب کریں',
  smartDocOr: 'یا',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'خرابی',
  unknownError: 'نامعلوم خرابی',
  file: 'فائل',
  loading: 'لوڈ ہو رہا ہے...',
  localFolders: 'مقامی فولڈرز',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'محفوظ',
  renameFile: 'نام تبدیل',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI تجزیہ',
};
